import React, { useEffect, useState } from "react";
import {
  LayoutGrid,
  CalendarDays,
  CreditCard,
  Tag,
  Building2,
  Users,
  BarChart3,
  FileText,
  Circle,
} from "lucide-react";
import "./verticalMenu.css"; // file css riêng

export default function VerticalMenu(props) { 
  const { data, select } = props;
  const [open, setOpen] = useState(false);

  const subParentLabel = data?.option5 || data?.option4;
  const topOptions = [
    data?.option1,
    data?.option2,
    data?.option3,
    data?.option4,
  ].filter((label) => Boolean(label) && label !== subParentLabel);
  const subOptions = [
    data?.sub?.option1,
    data?.sub?.option2,
    data?.sub?.option3,
    data?.sub?.option4,
  ].filter(Boolean);
  const hasSubMenu = Boolean(subParentLabel) && subOptions.length > 0;
  const isSubActive = subParentLabel === select || subOptions.includes(select);

  useEffect(() => {
    if (isSubActive) setOpen(true);
  }, [isSubActive]);

  function onChangeItem(target, value, index)  {
    if (!value) return;
    props.onChangeItem(target, value, index);
  }

  function getIconByLabel(label, isSub = false) {
    const key = String(label || "").toLowerCase();

    if (key.includes("calendar") || key.includes("lịch")) return CalendarDays;
    if (key.includes("member") || key.includes("thành viên")) return CreditCard;
    if (key.includes("voucher") || key.includes("mã")) return Tag;
    if (key.includes("branch") || key.includes("chi nhánh")) return Building2;
    if (key.includes("guest") || key.includes("khách") || key.includes("user")) return Users;
    if (key.includes("report") || key.includes("dashboard") || key.includes("tổng quan")) return LayoutGrid;
    if (key.includes("stat") || key.includes("chart") || key.includes("biểu đồ")) return BarChart3;
    if (isSub) return Circle;
    return FileText;
  }

  return (
    <div className="sidebar">
      <nav className="rrt-nav-like">
        {topOptions.map((label) => (
          <button
            key={label}
            type="button"
            className={"menu-item" + (label === select ? " active" : "")}
            onClick={() => onChangeItem("typeTabMenuSelect", label, undefined)}
          >
            <span className="menu-item-content">
              {React.createElement(getIconByLabel(label), { size: 16, className: "menu-icon" })}
              <span>{label}</span>
            </span>
          </button>
        ))}

        {hasSubMenu && (
          <>
            <button
              type="button"
              className={"menu-item" + (isSubActive ? " active" : "") + (open ? " open" : "")}
              onClick={() => {
                setOpen(!open);
                onChangeItem("typeTabMenuSelect", subParentLabel, undefined);
              }}
            >
              <span className="menu-item-content">
                {React.createElement(getIconByLabel(subParentLabel), { size: 16, className: "menu-icon" })}
                <span>{subParentLabel}</span>
              </span>
              <span className="arrow">{open ? "▾" : "▸"}</span>
            </button>

            {open && subOptions.length > 0 && (
              <div className="submenu">
                {subOptions.map((label) => (
                  <button
                    key={label}
                    type="button"
                    className={"submenu-item" + (label === select ? " active" : "")}
                    onClick={() => onChangeItem("typeTabMenuSelect", label, undefined)}
                  >
                    {React.createElement(getIconByLabel(label, true), { size: 13, className: "submenu-icon" })}
                    <span>{label}</span>
                  </button>
                ))}
              </div>
            )}
          </>
        )}
      </nav>
    </div>
  );
}
